import { useEffect, useRef, useState } from 'react'
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';
import OpenInNewOutlinedIcon from '@mui/icons-material/OpenInNewOutlined';
import Tooltip from './Tooltip';
import buildShareUrl from '../../helpers/buildShareUrl';

// Hoe lang de bevestiging blijft staan. Eén seconde was te kort om te zien
// (testronde 2026-10-13, B6).
const MESSAGE_MS = 2500

/**
 * Kopieert een deellink naar het klembord en zegt of dat gelukt is.
 *
 * @param {object} props
 * @param {string} props.link - Pad van de link (zonder host); buildShareUrl maakt er een volledige url van
 * @param {boolean} [props.showOpen] - Toont ook een knop die de link in een nieuw tabblad opent
 * @param {string} [props.label] - Een knop met deze tekst in plaats van het icoon met tooltip
 */
const CopyLink = ({link, showOpen = false, label = ''}) => {
    const [status, setStatus] = useState(/** @type {'copied'|'failed'|''} */ (''))
    /** @type {React.MutableRefObject<ReturnType<typeof setTimeout>|null>} */
    const timer = useRef(null)

    useEffect(() => () => clearTimeout(timer.current), [])

    const host = window.location.hostname
    // De link kan nog ontbreken (op 'Vragenlijst delen' tot er een meetmoment
    // gekozen is); bouwen zou dan het hele scherm laten vallen.
    const url = link ? buildShareUrl(host, link) : ''

    const copyToClipboard = async () => {
        // Pas 'Gekopieerd!' als het klembord het echt heeft; een geweigerde
        // schrijfactie zegt dat ook (bv. zonder toestemming van de browser).
        let next = 'copied'
        try {
            await navigator.clipboard.writeText(url)
        } catch (error) {
            console.error('Link kopiëren mislukt', error)
            next = 'failed'
        }
        setStatus(next)
        clearTimeout(timer.current)
        // Een mislukking blijft staan: de link moet dan met de hand te
        // selecteren zijn, en dat lukt niet in 2,5 seconden (testronde
        // 2026-10-15, B4).
        if (next === 'copied') timer.current = setTimeout(() => setStatus(''), MESSAGE_MS)
    }

  return (
    <div className='copy-link-container'>
        {label ? (
            <button type='button' onClick={copyToClipboard}>{label}</button>
        ) : (
            <Tooltip content='Kopieer link' top='-60px'>
                <ContentCopyOutlinedIcon className='icon-margin-left table-delete-icon' onClick={copyToClipboard} />
            </Tooltip>
        )}
        {showOpen && url && (
            <Tooltip content='Open link' top='-60px'>
                <a href={url} target='_blank' rel='noopener noreferrer' aria-label='Open link' className='copy-link-open'>
                    <OpenInNewOutlinedIcon className='icon-margin-left table-delete-icon' />
                </a>
            </Tooltip>
        )}
        {status && (
            <p className={status === 'copied' ? 'copied' : 'copied copied--failed'} role='status'>
                {status === 'copied' ? 'Gekopieerd!' : (
                    <>Kopiëren lukte niet. Selecteer de link en kopieer hem zelf: <span className='copy-link-url'>{url}</span></>
                )}
            </p>
        )}
    </div>
  )
}

export default CopyLink
